import type { ReactElement } from 'react';
import { Switch } from '@/components/ui/switch';

interface DataCollectionToggleProps {
  value: boolean;
  onChange: (storeInDb: boolean) => void;
  saving?: boolean;
  canEdit?: boolean;
}

export function DataCollectionToggle({
  value,
  onChange,
  saving = false,
  canEdit = true,
}: DataCollectionToggleProps): ReactElement {
  return (
    <div className="flex items-center gap-3">
      <Switch
        data-testid="data-collection-toggle"
        checked={value}
        onCheckedChange={onChange}
        disabled={saving || !canEdit}
        aria-label="Allow agent chat data collection for training"
      />
      <span
        className={`text-sm ${
          value ? 'font-medium text-primary' : 'text-muted-foreground'
        }`}
      >
        {value ? 'Enabled' : 'Disabled'}
      </span>
    </div>
  );
}

DataCollectionToggle.displayName = 'DataCollectionToggle';
